import React from 'react'

const Assistant = () => {
  return (
    <div>Assistant</div>
  )
}

export default Assistant